<template>
  <b-card :class="['card-challenges-ranking', color]" no-body header-tag="header" footer-tag="footer" style="cursor: default">
    <template v-slot:header class="d-flex">
      <span class="badge">
        <font-awesome-icon :icon="[icon.type, icon.name]" />
      </span>
          <h2 class="title">
            <PuSkeleton :loading="isLoading" :count="1" width='120px'>                        
              {{title}}
            </PuSkeleton>
          </h2>
    </template>
    <b-card-text>
      <b-list-group>

      <b-list-group-item v-for="(list,index) in lists" :key="index">
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height="20px">                        
            <p v-if="list != null" class="increase" :class="[isPositif = diffBool(list.previousRank,list.rank) ? 'negatif' : 'positif']">{{diffBool(list.previousRank,list.rank) ? '-' : '+' }} {{diff(list.previousRank,list.rank)}}</p>
            <p v-if="list != null" class="number" >{{list.rank}}</p>
            <p v-if="list != null" class="fullname" style="width: 150px; white-space: nowrap;overflow:hidden;text-overflow: ellipsis;">{{list.name}}</p>
            <p v-if="list != null" class="result">{{Math.round(list.points).toLocaleString()}}</p>
          </PuSkeleton>
        </b-list-group-item>
      </b-list-group>
    </b-card-text>
  </b-card>

</template>


<script>
import Utils from '../../Utils'
//
export default {
  name: "CardChallengesRanking",
  components:{ 
  },
  props:{
    color:{
      type:String,
      default:'blue'
    },
    title:{
      type:String,
      default:'Top semaine'
    },
    icon :{
      type:Object,
      default () {
        return {
          type :'fas',
          name :'trophy-alt'
        }
      } 
    },
    isLoad:{
      type:Boolean,
      default: true
    },
    lists:{
      type:Array,
      default:() => [null, null, null]
    }
  },
  data(){
    return {    
        isLoading:true,
        isPositif : true
    }
  },
  methods : {
    diff: function(start,end){
      return Utils.compare(start,end);
    },    
    diffBool: function(start,end){
      return Utils.compareBool(start,end);
    }     
  }, 
  mounted (){

    // const targets = this.$el.querySelectorAll('.increase');
    // targets.forEach(element => {
    //   if(Utils.getFirstLetter(element.innerHTML) == true){
    //     element.classList.add('negatif');
    //   } else if(Utils.getFirstLetter(element.innerHTML) == false){
    //     element.classList.add('positif');
    //   }
    // });
  },
  created(){
    this.isLoading = this.isLoad;
  },
  watch : {
    'isLoad' : function (){
    this.isLoading = this.isLoad;    
    },
  }   
}
</script>
